import { useState } from "react";
import { CUSTOMERS, type Customer } from "@/data/customers";

function LogoTile({ customer, onLime }: { customer: Customer; onLime?: boolean }) {
  const [failed, setFailed] = useState(false);

  return (
    <div className="shrink-0 w-[200px] md:w-[240px]">
      <div
        className={`group h-[130px] md:h-[150px] flex items-center justify-center px-6 ${
          onLime
            ? "bg-white border border-black/10 shadow-[0_1px_0_rgba(0,0,0,0.12)]"
            : ""
        }`}
      >
        {failed ? (
          <span
            className={`font-mono text-[11px] uppercase tracking-[0.28em] text-center ${
              onLime ? "text-black/70" : "text-white/70"
            }`}
          >
            {customer.name}
          </span>
        ) : (
          <img
            src={customer.logo}
            alt={customer.alt}
            loading="lazy"
            decoding="async"
            onError={() => setFailed(true)}
            className="max-h-[80px] max-w-[150px] object-contain"
          />
        )}
      </div>
      <p
        className={`mt-3 font-mono text-[10px] uppercase tracking-[0.3em] text-center ${
          onLime ? "text-black/60" : "text-white/55"
        }`}
      >
        {customer.name}
      </p>
    </div>
  );
}

export default function CustomersCarousel({ onLime = false }: { onLime?: boolean }) {
  const loop = [...CUSTOMERS, ...CUSTOMERS];

  return (
    <div
      className={`pr-logo-strip relative overflow-hidden ${onLime ? "pr-logo-strip--on-lime" : ""}`}
      style={{
        maskImage: "linear-gradient(to right, transparent, #000 8%, #000 92%, transparent)",
        WebkitMaskImage: "linear-gradient(to right, transparent, #000 8%, #000 92%, transparent)",
      }}
    >
      <div
        className="flex anim-marquee gap-4 md:gap-8"
        style={{ width: "max-content" }}
      >
        {loop.map((c, i) => (
          <LogoTile key={`${c.name}-${i}`} customer={c} onLime={onLime} />
        ))}
      </div>
    </div>
  );
}
